<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">For Liam<br/><br/>Here’s a nice jungle: glades of trust<br/>Disturbed by parakeets of lust,<br/>Pools of deceptive calm where need<br/>Bathes among crocodiles of greed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// strangeloyalties_00000.vue?037615d0